import { useLocation } from "react-router-dom";
import { useSEO } from "@/hooks/useSEO";
import { seoConfig, defaultSEO } from "@/config/seoConfig";

/**
 * Reads the current route from the router and applies the matching SEO
 * entry from the centralized `seoConfig` map. Rendered once near the root
 * of the app so every page gets correct, unique metadata without each
 * page needing its own useSEO call.
 *
 * Pages that still call useSEO directly will simply override these values
 * — but the config guarantees a sensible, non-duplicate baseline for
 * every route, including ones that forget to set metadata.
 */
export function RouteSEO() {
  const { pathname } = useLocation();
  const entry = seoConfig[pathname] ?? defaultSEO;

  useSEO({
    title: entry.title,
    description: entry.description,
    canonical: entry.canonical,
    robots: entry.robots,
    ogImage: entry.ogImage,
    ogType: entry.ogType,
  });

  return null;
}
